import breakpoints from 'constants/breakpoints';
import styled from 'styled-components';
import theme from 'themes';

const FlyoutContainer = styled.div`
  font-family: Roboto;
  .flyout-header {
    border-bottom: 1px solid black;
  }
  .product-code {
    margin: 0;
  }
`;
const HeaderContainer = styled.div`
  display: flex;
  padding: 1rem 0 1.25rem;
  margin: 0 1.25rem;
  border-bottom: 1px solid ${theme.colors.tableborder};
  .close-btn {
    margin-left: auto;
  }
`;
const Error = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const ViewContainer = styled.div``;
const SavedProduct = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  @media (max-width: ${breakpoints.size.md}px) {
    max-width: 100%;
    margin-right: 0;
  }
`;
const FavoriteText = styled.div`
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;
const PartDetail = styled.div`
  width: 20rem;
  padding: 0.5rem;
  .part-info {
    word-wrap: break-word;
    display: inline-block;
    white-space: normal; /* Ensures the text can wrap */
    overflow-wrap: break-word; /* Modern browsers */
    word-break: break-word; /* Fallback */
    max-width: 15rem;
    flex: 1;
  }
  .part-info-text {
    max-width: 11rem;
    word-wrap: break-word;
    display: inline-block;
    white-space: normal; /* Ensures the text can wrap */
    overflow-wrap: break-word; /* Modern browsers */
    word-break: break-word; /* Fallback */
  }
`;
const ImageContainer = styled.div`
  width: 8rem;
  text-align: center;
`;
const PartImage = styled.img`
  width: 100%;
  max-height: 100%;
  height: 6rem;
  object-fit: contain;
`;

export {
  Error,
  ViewContainer,
  SavedProduct,
  FlyoutContainer,
  HeaderContainer,
  PartImage,
  PartDetail,
  ImageContainer,
  FavoriteText
};
